import "./AllCompanies.scss";
import { Fragment } from "react";
import { baseUrl } from "../../../utils/apiData";
import { useNavigate } from "react-router-dom";

const AllCompanies = ({ dataList, tagTitle, des }) => {
  const navigate = useNavigate();
  return (
    <section className="all_companies">
      <div className="content_wrap p_top p_bottom">
        <div className="title">
          <h2 className="wow fadeInUp">{des}</h2>
        </div>
        <div className="companies_bigrid">
          {dataList?.map((data, j) => {
            return (
              <Fragment key={data?._id}>
                <div
                  className="companies_card wow fadeInUp"
                  data-wow-delay={`${(j % 2) * 0.1}s`}
                  onClick={() => navigate(`/vendors/${data?.slug}`)}
                >
                  <div className="text">
                    <h5><b>{data?.name}</b></h5>
                    <p className="t-14">{data?.small_description}</p>
                  </div>
                  <div className="img_wrap">
                    <img src={`${baseUrl}/${data.image}`} alt="Company" />
                  </div>
                </div>
              </Fragment>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AllCompanies;
